export const SCRIPT_ON_DEMAND_NAME = 'script-on-demand';

export const loadScriptOnDemand = ($el) => {
  const src = $el.data('src');
  if (!src) {
    console.error('A \'data-src\' is required for a lazy script-on-demand');
    return;
  }

  const scriptAttrs = $el.data('scriptAttrs') || {};
  const script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.async = true;

  Object
    .keys(scriptAttrs)
    .map((attrName) => {
      script.dataset[attrName] = scriptAttrs[attrName];
    });

  $el[0].appendChild(script);

  $el
    .removeAttr('data-src')
    .removeAttr('data-script-attrs');
};



// WEBPACK FOOTER //
// ./src/scripts/modules/lazy/script-on-demand.js